// extracted by mini-css-extract-plugin
export var body = "DIT1_DGJl8_mskQZWge3";
export var fontBold = "DFOn4W26AJqBvW4cYKnJ";
export var fontMedium = "X_fHqAiziytoDCnGuhwx";
export var fontRegular = "u9By4O0TmJDQB3gvapY8";
export var large = "p7ufZCY4XfZHXJ15i7F5";
export var micro = "B86VhtiRXDGYyB1Q1gJ4";
export var mini = "HE9qTFNwlZS4qxu41iSt";
export var root = "pDL5jIStuXyRbKul6GgM";
export var small = "CnhS9XYa8V1RLlV0lmZV";